import React, { useState, useEffect, useCallback } from 'react';
import './ReviewTemplateEditorPage.css';
import TemplateEditorPanel from './TemplateEditorPanel';
import DynamicReviewForm from '../../components/DynamicReviewForm';
import { getTemplate, saveTemplate } from '../../api/templateService';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import useUpdateBreadcrumbs from '../../hooks/useUpdateBreadcrumbs';
import useLocale from '../../hooks/useLocale';

const ReviewTemplateEditor = () => {
  // was conference_id, now festschrift_id to match routes + backend
  const { festschrift_id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const sp = new URLSearchParams(location.search);
  const confName = sp.get('conferenceName') || '';
  const [template, setTemplate] = useState([]);
  const [loading, setLoading] = useState(true);
  const [draggedBlockType, setDraggedBlockType] = useState(null);
  const { getCurrentLanguage } = useLocale();
  const lang = getCurrentLanguage();

  const loadTemplate = async (fsId) => {
    return await getTemplate(fsId);
  };

  const setBreadcrumbs = useCallback(
    (search) => {
      const searchParams = new URLSearchParams(search);
      const confName = searchParams.get('conferenceName');
      return [
        {
          label: confName,
          // management is now festschrift-based
          url: `/management/publishing/${festschrift_id}?conferenceName=${encodeURIComponent(confName)}`,
        },
      ];
    },
    [festschrift_id],
  );
  useUpdateBreadcrumbs(setBreadcrumbs);

  useEffect(() => {
    const initialLoad = async () => {
      try {
        const loadedTemplate = await loadTemplate(festschrift_id);
        setTemplate(loadedTemplate?.blocks ?? []);
      } finally {
        setLoading(false);
      }
    };
    initialLoad();
  }, [festschrift_id]);

  const saveTemplateHandler = async () => {
    console.log('Сохранённый шаблон:', template);
    try {
      await saveTemplate(festschrift_id, template);
      alert(lang === 'ru' ? 'Шаблон сохранён!' : 'Template saved!');
      navigate(
        `/management/publishing/${festschrift_id}?conferenceName=${encodeURIComponent(confName)}`,
      );
    } catch (error) {
      console.error('Ошибка сохранения шаблона:', error);
      alert(lang === 'ru' ? 'Ошибка сохранения шаблона' : 'Failed to save template');
    }
  };

  const resetTemplate = () => {
    const reload = async () => {
      const loadedTemplate = await loadTemplate(festschrift_id);
      setTemplate(loadedTemplate?.blocks ?? []);
    };
    reload();
  };

  if (loading) {
    return (
      <div className="loading-state">
        {lang === 'ru' ? 'Загрузка шаблона...' : 'Loading template...'}
      </div>
    );
  }

  return (
    <div className="review-template-editor">
      <div className="editor-layout">
        <div className="left-panel">
          <h2 className="panel-title">
            {lang === 'ru' ? 'Редактор шаблона отзыва' : 'Review template editor'}
          </h2>
          <TemplateEditorPanel
            template={template}
            setTemplate={setTemplate}
            draggedBlockType={draggedBlockType}
            setDraggedBlockType={setDraggedBlockType}
          />
        </div>
        <div className="right-panel">
          <h2 className="panel-title">{lang === 'ru' ? 'Предпросмотр формы' : 'Form preview'}</h2>
          <DynamicReviewForm template={template} editable={false} />
        </div>
      </div>
      <div className="editor-actions">
        <button onClick={saveTemplateHandler} className="save-btn">
          {lang === 'ru' ? 'Сохранить шаблон' : 'Save template'}
        </button>
        <button onClick={resetTemplate} className="reset-btn">
          {lang === 'ru' ? 'Сбросить шаблон' : 'Reset template'}
        </button>
      </div>
    </div>
  );
};

export default ReviewTemplateEditor;
